import React, { Component } from 'react';
// react modal
import ReactModal from 'react-modal';
// react redux connect
import { connect } from 'react-redux';
// styled components
import styled from 'styled-components';
// js moment
import moment from 'moment';
// redirect if user does not have access
import { Redirect } from "react-router-dom";
// material ui pickers
import MomentUtils from '@date-io/moment';
// Big Calendar imports
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from 'react-big-calendar'

import "../../assets/css/modal-scroll.css";

// material ui core imports
import {
  Grid,
  Button,
  CircularProgress,
  IconButton,
  InputLabel,
  TextField,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Divider,
  Select,
  MenuItem,
} from "@material-ui/core";

// icon imports
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

// material ui pickers imports
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// component imports
import {
  EventsCard,
  ItemGrid,
  DailySpecialCard,
  UploadButton
} from "../../components";

// reducer imports
import {
  loadEvents,
  createNewEvent,
  editEvent,
  changeFeature,
  changeStarred,
  deleteAllEventOccurrences,
  deleteEvent,
  saveSpecials,
  loadSpecials
} from './reducer/actions';

// if either Start Time or End Time of an event are null,
// then the event runs all day
const getTimeFrame = (event) => {
  const startTime = event.from;
  const endTime = event.to;
  const allDay = startTime == null || endTime == null;
  return allDay ? 'All day' : `${startTime} to ${endTime}`;
};

// parses the time an event begins and ends
const getHhMm = time => {
  if (time == null) return null;
  const mtime = moment(time, 'HH:MM');
  const minutes = parseInt(mtime.format('m'), 10);

  return mtime.format(minutes !== 0 ? 'h:mma' : 'ha').toUpperCase();
}

// modal styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)',
    zIndex: 10,
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px',
  }
};

// You don't go to Bombay, India to become a movie star!
// You go where we're going! Hollywood!

// class declaration
class EventView extends Component {

  // constructor with state initialization and function binding
  constructor(props){
    super(props);

    this.state = {
      isLoading: false,
      isEditing: false,
      editingEvent: '',
      showModal: false,
      showEvents: 0,
      specialTabId: 0,
      /* new event state */
      ne_title: '',
      ne_date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      ne_from: moment().format('YYYY-MM-DDTHH:mm:ss'),
      ne_to: moment().format('YYYY-MM-DDTHH:mm:ss'),
      ne_allDay: true,
      ne_details: '',
      ne_image: null,
      ne_repeat: 'never',
      ne_featured: false,
      ne_starred: false,
      /* current special state */
			sp_title: '',
			sp_content: '',
      /* TODO: determine if Special Image actually displays anywhere */
      sp_image: null,
      /* custom action button states */
      ne_customActionButton_action: '',
      ne_customActionButton_link: '',
      ne_customActionButton_title: '',
      ne_customActionButton_visible: false,
      /* calendar specific state */
      calendarStart: moment().format('YYYY-MM-DDTHH:mm:ss'),
      calendarEnd: moment().format('YYYY-MM-DDTHH:mm:ss'),
    }

    // binds
    this.initEditEvent = this.initEditEvent.bind(this);
    this._onEditEvent = this._onEditEvent.bind(this);
    this._onCreateNewEvent = this._onCreateNewEvent.bind(this);
    this._onChangeFeature = this._onChangeFeature.bind(this);
    this._onChangeStarred = this._onChangeStarred.bind(this);
    this._onDeleteEvent = this._onDeleteEvent.bind(this);
    this._onDeleteAllEvents = this._onDeleteAllEvents.bind(this);
		this._onSaveSpecial = this._onSaveSpecial.bind(this);
    this.onChangeSpecialTab = this.onChangeSpecialTab.bind(this);
    this._onDeleteImage = this._onDeleteImage.bind(this);
  }

  // load in specials and events
  componentWillMount() {
    this.setState({ isLoading: true });
		this.props.loadEvents(this._onSuccess.bind(this), this._onError.bind(this));
		this.props.loadSpecials(() => this.onChangeSpecialTab(0));
  }

  // on successful load or operation
	_onSuccess() {
		this.setState({ isLoading: false, showModal: false });
	}

  // on unsuccessful load or operation
	_onError(error) {
    console.log(error);
    this.setState({ isLoading: false, showModal: false });
	}
  // calls reducer to delete an event
  _onDeleteEvent(id) {
    this.props.deleteEvent(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  _onDeleteAllEvents(id) {
    this.props.deleteAllEventOccurrences(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // change a non-featured event to featured and vice-versa
  _onChangeFeature(id) {
    const { allEvents } = this.props;
    const curEvent = allEvents.filter(evt => {
      return evt.id === id
    })[0];

    this.props.changeFeature(
      id,
      !curEvent.isFeatured,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // change a non-starred event to be starred and vice-versa
  // initially implemented for use for singling out Lunch Specials
  _onChangeStarred(id) {
    const { allEvents } = this.props;
    const curEvent = allEvents.filter(evt => {
      return evt.id === id
    })[0];
    this.props.changeStarred(
      id,
      !curEvent.isStarred,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // begin to edit an event
  initEditEvent(id) {
    const { allEvents } = this.props;
    const curEvent = allEvents.filter(evt => {
      return evt.id === id
    })[0];
    const ne_from = curEvent.from ?
      moment(curEvent.from, ['h:ma', 'ha', 'h:m a', 'H:m'])
      :
      null;
    const ne_to = curEvent.to ?
      moment(curEvent.to, ['h:ma', 'ha', 'h:m a', 'H:m'])
      :
      null;

    let actionButtonAction = null;
    let actionButtonTitle ='';
    let actionButtonVisible = false;
    let actionButtonLink = '';
    // error checking
    if(curEvent.hasOwnProperty('customButton')){
      actionButtonTitle = curEvent.customButton.title;
      actionButtonVisible = curEvent.customButton.visible
      if(curEvent.customButton.hasOwnProperty('action')){
        actionButtonAction = Object.keys(curEvent.customButton.action)[0];
        // check for more actions here when implementing more actions
        if(curEvent.customButton.action.hasOwnProperty('link')){
          actionButtonLink = curEvent.customButton.action.link;
        }
      }
    }

    this.setState({
      ne_title: curEvent.title,
      ne_details: curEvent.details,
      ne_repeat: curEvent.repeat || 'once',
      ne_featured: curEvent.isFeatured,
      ne_starred: curEvent.isStarred,
      ne_date: curEvent.date,
      ne_image: curEvent.image,
      ne_from,
      ne_to,
      ne_allDay: ne_from === null || ne_to === null,
      isEditing: true,
      editingEvent: id,
      showModal: true,
      ne_customActionButton_action: actionButtonAction,
      ne_customActionButton_link: actionButtonLink,
      ne_customActionButton_title: actionButtonTitle,
      ne_customActionButton_visible: actionButtonVisible,
      // calendar specific
      calendarStart: curEvent.calendarStart || null,
      calendarEnd: curEvent.calendarEnd || null,
    });
  }

  // called once Edit button is pressed on an event
  _onEditEvent(id) {
    var date = moment(this.state.ne_date);
    // set action object
    var action = null;
    if(this.state.ne_customActionButton_action === 'link'){
      action = {[this.state.ne_customActionButton_action]: this.state.ne_customActionButton_link}
    }
    // add more actions here when ready to implement
    const data = {
      title: this.state.ne_title,
      date: date.format('YYYY-MM-DDTHH:mm:ss'),
      from: this.state.ne_allDay ? null : getHhMm(this.state.ne_from),
      to: this.state.ne_allDay ? null : getHhMm(this.state.ne_to),
      details: this.state.ne_details,
      image: this.state.ne_image || null,
      repeat: this.state.ne_repeat,
      isFeatured: this.state.ne_featured || false,
      isStarred: this.state.ne_starred || false,
      id: id,
      calendarEnd: this.state.ne_allDay? moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'): date.format('YYYY-MM-DDTHH:mm:ss'),
      calendarStart: this.state.ne_allDay? moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'): date.format('YYYY-MM-DDTHH:mm:ss'),
      customButton: {
        action,
        title: this.state.ne_customActionButton_title,
        visible: this.state.ne_customActionButton_visible,
      },
    };

    this.props.editEvent(
      id,
      data,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // create a brand new event
  _onCreateNewEvent() {
    let state_date = this.state.ne_date;
    // console.log('STATE',this.state.ne_date);
    // console.log("FORMAT", moment(state_date).format('YYYY-MM-DDTHH:mm:ss'));
    // console.log("REG", moment(state_date).format());
    var date = moment(this.state.ne_date);
    
    // set action object
    var action = null;
    if(this.state.ne_customActionButton_action === 'link'){
      action = {[this.state.ne_customActionButton_action]: this.state.ne_customActionButton_link}
    }
    // add more actions here when ready to implement
    this.props.createNewEvent({
      title: this.state.ne_title,
      date: date.format('YYYY-MM-DDTHH:mm:ss'),
      from: this.state.ne_allDay ? null : getHhMm(this.state.ne_from),
      to: this.state.ne_allDay ? null : getHhMm(this.state.ne_to),
      details: this.state.ne_details,
      image: this.state.ne_image,
      repeat: this.state.ne_repeat,
      isFeatured: this.state.ne_featured,
      isStarred: this.state.ne_starred,
      // start of day for BOTH because on the calendar view, it brings the event to the top of the calendar
      calendarEnd: this.state.ne_allDay? moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'): this.state.calendarEnd,
      calendarStart: this.state.ne_allDay? moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss'): this.state.calendarStart,
      customButton: {
        action,
        title: this.state.ne_customActionButton_title,
        visible: this.state.ne_customActionButton_visible,
      }
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // show modal to create new Event and set the state accordingly
  _onShowModal(date) {
    this.setState({
      ne_date: date,
      ne_title: '',
      ne_details: '',
      ne_allDay: true,
      ne_image: null,
      ne_repeat: 'once',
      ne_featured: false,
      ne_starred: false,
      ne_from: null,
      ne_to: null,
      isEditing: false,
      editingEvent: null,
      showModal: true,
      ne_customActionButton_action: null,
      ne_customActionButton_link: '',
      ne_customActionButton_title: '',
      ne_customActionButton_visible: false, 
      // calendar specific
      calendarStart: null,
      calendarEnd: null,
    });
  }

  // close the modal
  _onCloseModal() {
    this.setState({ showModal: false });
  }

  // change currently viewed tab
  onChangeTab(t) {
    this.setState({
      showEvents: t
    });
  }

  // called when Daily Special tabs are changed
  onChangeSpecialTab(tabId) {
		const dailySpecial = this.props.dailySpecials;
		const title = dailySpecial[tabId] ? dailySpecial[tabId].title : '';
		const content = dailySpecial[tabId] ? dailySpecial[tabId].content : '';
    const image = dailySpecial[tabId] ? dailySpecial[tabId].image : null;

    this.setState({
      specialTabId: tabId,
      sp_title: title,
      sp_content: content,
      sp_image: image,
    });
  }

  // called to save a new Daily Special
	_onSaveSpecial() {
    // get all specials
		var specials = this.props.dailySpecials;
    // if there are no specials, set an empty array
		if (!specials) {
     specials = [];
    }
    // get the image
    let image = null;
    if (this.state.sp_image) {
      image = this.state.sp_image;
    }
    // set location in special array
		specials[this.state.specialTabId] = {
      title: this.state.sp_title,
      content: this.state.sp_content,
      image: image,
    };
    // save specials
		this.props.saveSpecials(specials);
	}

  // Deletes the image from the Daily Special
  _onDeleteImage() {
  	var specials = this.props.dailySpecials;
  	if (!specials) {
     specials = [];
    }
  	specials[this.state.specialTabId] = {
      title: this.state.sp_title,
      content: this.state.sp_content,
      image: null,
    };
  	this.props.saveSpecials(specials);
    this.setState({sp_image: null});
  }

  // create or edit an event via the modal
  createEventModal() {
    if (!this.state.showModal) {
      return null;
    }
    return (
      <ReactModal isOpen={this.state.showModal}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Event' : 'New Event'}
        ariaHideApp={false}
        style={customModalStyles}
      >
        {/* modal top header */}
        <ModalHeader>
          {this.state.isEditing ? 'Edit Event' : 'New Event'}
        </ModalHeader>
        <ModalContent>
          {/* Event Title */}
          <TextField
            label={'Title'}
            value={this.state.ne_title}
            onChange={(evt) =>
              {this.setState({ ne_title: evt.target.value })}}
          />
          <br/>
          {/* Event Date */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <DatePicker
              label={'Event Date'}
              value={this.state.ne_date}
              onChange={(date) => {this.setState({ ne_date: date })}}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.ne_allDay}
                  onChange={(e, c) => {this.setState({ ne_allDay: c })}}
                  value="checkedAD" />
              }
              label="All day event"
            />
          </div>
          {/* Event Start/End Times - disabled if it's an All Day event */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between' }}
          >
            <TimePicker disabled={this.state.ne_allDay}
              label={'Start Time'}
              value={this.state.ne_from}
              onChange={(e) => {
                // let PMorAM
                let hours = e.format('HH');
                let minutes = e.format('mm');
                let date = moment(this.state.ne_date);
                date.hours(hours);
                date.minutes(minutes);
                const newDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
                this.setState({ ne_from: e, calendarStart: newDate });
              }}
            />
            <TimePicker disabled={this.state.ne_allDay}
              label={'End Time'}
              value={this.state.ne_to}
              onChange={(e) => {
                let hours = e.format('HH');
                let minutes = e.format('mm');
                let date = moment(this.state.ne_date);
                date.hours(hours);
                date.minutes(minutes);
                const newDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
                this.setState({ ne_to: e, calendarEnd: newDate });
              }}
            />
          </div>
          {/* Event Details */}
          <TextField
            label={'Details'}
            style={{ width: '100%' }}
            multiline={true}
            rowsMax={4}
            value={this.state.ne_details}
            onChange={(e) => {this.setState({ ne_details: e.target.value })}} 
          />
          <div>
            <br/>
            <Divider/>
          </div>
          {/* How frequently an event should Recur, if at all */}
          <div style={{display: 'flex', alignItems: 'center'}}>
            <div style={{width: '70%'}}>
              <FormControl component="fieldset" className="radiogroup">
                <FormLabel component="legend">
                  Repeat
                </FormLabel>
                <RadioGroup name={'repeat'}
                  defaultSelected={this.state.ne_repeat}
                  value={this.state.ne_repeat}
                  onChange={(e) => {this.setState({ ne_repeat: e.target.value })}}
                >
                  <FormControlLabel
                    value="once"
                    control={<Radio />}
                    label={'Once'}
                  />
                  <FormControlLabel
                    value="day"
                    control={<Radio />}
                    label={'Every Day'}
                  />
                  <FormControlLabel
                    value="weekly"
                    control={<Radio />}
                    label={'Every Week'}
                  />
                  <FormControlLabel
                    value="2weeks"
                    control={<Radio />}
                    label={'Every 2 Weeks'}
                  />
                  <FormControlLabel
                    value="month"
                    control={<Radio />}
                    label={'Every Month'}
                  />
                  <FormControlLabel
                    value="year"
                    control={<Radio />}
                    label={'Every Year'}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {/* Featured ? */}
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<FavoriteBorderIcon />}
                    checkedIcon={<FavoriteIcon />}
                    checked={this.state.ne_featured}
                    onChange={(e, c) => {this.setState({ ne_featured: c })}}
                    value="checked"
                  />
                }
                label="Featured Event"
              />
              {/* Starred ? */}
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<StarBorderIcon />}
                    checkedIcon={<StarIcon />}
                    checked={this.state.ne_starred}
                    onChange={(e, c) => {this.setState({ ne_starred: c })}}
                    value="checked"
                  />
                }
                label="Starred Event"
              />
              {/* Event image */}
              <UploadButton
                storage="events"
                style={{width: '250px', height: '150px'}}
                value={this.state.ne_image}
                onUploadComplete={ne_image => this.setState({ ne_image })}
              />
            </div>
          </div>
          <Divider/>
          <div>
            <TextField
              label={'Button Title'}
              value={this.state.ne_customActionButton_title}
              onChange={(evt) =>
                {this.setState({ ne_customActionButton_title: evt.target.value })}}
            />
            {/* <br/> */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.ne_customActionButton_visible}
                  onChange={(e, c) => {this.setState({ ne_customActionButton_visible: c })}}
                  value="checked"
                />
              }
              label="Visible"
            />
            <br/>
            <FormControl style={{display:'flex', width:'50%',}} fullWidth={false}>
              <InputLabel>Action</InputLabel>
              <Select
                autoWidth={true}
                labelId="customActionButtonAction"
                id="customActionButton-selectAction"
                value={this.state.ne_customActionButton_action}
                onChange={evt => {this.setState({ne_customActionButton_action: evt.target.value})}}
              >
                <MenuItem value={''}>none</MenuItem>
                <MenuItem value={'link'}>Link</MenuItem>
                {/* when more actions are requested to be implemented, put the option to select here */}
              </Select>
            </FormControl>
            {/* only when and action is selected should the controls be shown */}
            {/* link input is shown when action, 'Link', is selected */}
            {this.state.ne_customActionButton_action === 'link'?<TextField
              label={'paste link here ...'}
              fullWidth={true}
              value={this.state.ne_customActionButton_link}
              onChange={(evt) =>
                {this.setState({ ne_customActionButton_link: evt.target.value })}}
            />:null}
          </div>
        </ModalContent>
        {/* Create or Edit button, Cancel button */}
        <ModalFooter>
          <Button variant='raised'
            primary={true}
            onClick={(e) => {this.state.isEditing ?
              this._onEditEvent(this.state.editingEvent) : this._onCreateNewEvent()}
            }
          >
            {this.state.isEditing ? 'Edit' : 'Create'}
          </Button>
          { this.state.isEditing ?
            <Button variant='raised'
              style={{ marginLeft: 20 }}
              onClick={(e) => this._onDeleteEvent(this.state.editingEvent)}
            >
              Delete
            </Button>
            : null
          }
          { this.state.isEditing && this.state.ne_repeat !== 'once' ?
            <Button variant='raised'
              style={{ marginLeft: 20 }}
              onClick={(e) => this._onDeleteAllEvents(this.state.editingEvent)}
            >
              Delete All
            </Button>
            : null
          }
          <Button variant='raised'
            style={{ marginLeft: 20 }}
            onClick={(e) => {this.setState({ isEditing: false, showModal: false })}}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // render all Daily Specials
  renderDailySpecials() {
    // if specials still loading, return
    if (this.props.specialLoading) {
      return null;
    }
    // otherwise, return special card
    return (
      <ItemGrid xs={12}>
        <DailySpecialCard onChangeTab={this.onChangeSpecialTab}>
          <Grid container>
            {/* display/allow editing of Title */}
            <ItemGrid xs={3}>
              <TextField
                style={{ width: '100%' }}
                label={'Title'}
                value={this.state.sp_title}
                onChange={(evt) => {this.setState({ sp_title: evt.target.value })}}
              />
            </ItemGrid>
            {/* display/allow editing of Content */}
            <ItemGrid xs={5}>
              <TextField
                label={'Content'}
                style={{ width: '100%' }}
                multiline={true}
                rowsMax={4}
                value={this.state.sp_content}
                onChange={(e) => {this.setState({ sp_content: e.target.value })}} />
            </ItemGrid>
            <ItemGrid xs={4}>
              {/* Upload an Image for the Daily Special */}
              <UploadButton
                storage="events"
                className="image-upload-button big-image"
                value={this.state.sp_image}
                onUploadComplete={sp_image => this.setState({ sp_image })}
              />
              {/* Delete Daily Special image */}
              <IconButton tooltip="Delete Header Image"
                iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                onClick={(e) => {this._onDeleteImage()}}>
                <DeleteIcon />
              </IconButton>
            </ItemGrid>
            {/* Save the Daily Special */}
            <ItemGrid xs={12}
              justify={'center'}
              alignItems={'center'}
            >
              <Button variant='raised'
                style={{marginTop: 30}}
                primary={true}
                onClick={(e) => {this._onSaveSpecial()}}
              >
                Save
              </Button>
            </ItemGrid>
          </Grid>
        </DailySpecialCard>
      </ItemGrid>
    )
  }

  // style Events in Calendar according to their frequency or type
  // TODO: if an event is Featured and/or Starred, that will override Repeat styles
  eventStyleGetter(e) {
    let backgroundColor = '';
    switch(e.repeat) {
    case 'once':
      backgroundColor = '#e8d3ee';
      break;
    case 'daily':
      backgroundColor = '#d1a7dd';
      break;
    case 'weekly':
      backgroundColor = '#bb7bcc';
      break;
    case 'biweekly':
      backgroundColor = '#a44fbb';
      break;
    case 'monthly':
      backgroundColor = '#8e24aa';
      break;
    case 'annually':
      backgroundColor = '#59176b';
      break;
    default:
      backgroundColor = '#e8d3ee';
      break;
    }
    if(e.isFeatured && e.isStarred) {
      backgroundColor = '#FD6A01';
    }
    else if(e.isFeatured) {
      backgroundColor = '#FF1200';
    }
    else if(e.isStarred) {
      backgroundColor= '#FCB001';
    }
    var style = {
      background: backgroundColor,
      borderRadius: '2px',
      opacity: 0.8,
      color: 'black',
      border: '0px',
      display: 'block'
    };
    return {
        style: style
    };
  }

  // Event Tabs showing All, Featured, or Recurring events
  renderEventCard(events) {
    return (
      <EventsCard onChangeTab={t => this.onChangeTab(t)}>
        {/* If there are no events, print placeholder text */}
        {(!events || events.length === 0) &&
          <div style={{width: '100%', textAlign: 'center'}}>
            No Events.
          </div>
        }
        {/* if there are events, map them accordingly */}
        {events && events.length > 0 && events
          .sort((a, b) => moment(a.date).diff(moment(b.date)))
          .map((event, id) => {
          return (
            <div
              key={id}
              style={{
                padding: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              {/* display event title */}
              <div style={{width: '10%'}}>
                {event.title}
              </div>
              {/* display event image */}
              <div
                style={{
                  width: 100,
                  height: 64,
                  backgroundColor: '#ccc',
                  backgroundImage: `url("${event.image}")`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50% 50%'
                }}
              />
              {/* display event date and time */}
              <div style={{width: '15%'}}>
                <strong>
                  {moment(event.date).format('ll')}
                </strong>
                {'; '}
                {getTimeFrame(event)}
              </div>
              {/* display event details */}
              <div style={{width: '40%'}}>
                {event.details}
              </div>
              {/* display Featured, Starred, Edit, and Delete boxes */}
              <div style={{display: 'flex', alignItems: 'center'}}>
                {/* turn Featured on/off for each Event */}
                <Checkbox
                  style={{marginLeft: 10}}
                  checkedIcon={<FavoriteIcon />}
                  icon={<FavoriteBorderIcon />}
                  checked={event.isFeatured}
                  onChange={(e,c)=>{this._onChangeFeature(event.id)}}
                />
                {/* turn on/off Starred for Event */}
                <Checkbox
                  style={{marginLeft: 10}}
                  checkedIcon={<StarIcon />}
                  icon={<StarBorderIcon />}
                  checked={event.isStarred}
                  onChange={(e, c)=>{this._onChangeStarred(event.id)}}
                />
                {/* Allow Editing an event */}
                <IconButton tooltip="Edit event"
                  iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                  onClick={(e) => {this.initEditEvent(event.id)}}
                >
                  <EditIcon />
                </IconButton>
                {/* Delete an event */}
                <IconButton tooltip="Delete event"
                  iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                  onClick={(e) => {this._onDeleteEvent(event.id)}}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            <Divider />
            </div>
          )})}
        {/* end of map return statement */}
        <Button onClick={this._onShowModal.bind(this)}>
          Add New Event
        </Button>
      </EventsCard>
    );
  }

  // render function
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'events'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('events'))
    {
      return (
        <Redirect from={'events'} to={'dashboard'} key={'noTicket'} />
      );
    }

    // set props
    const {
      recurringEvents,
      featuredEvents,
      starredEvents,
      allEvents
    } = this.props;

    // show different events depending on state
    var events = [];

    switch(this.state.showEvents) {
      case 1:
        events = featuredEvents;
        break;
      case 2:
        events = recurringEvents;
        break;
      case 3:
        events = starredEvents;
        break;
      default:
        events = allEvents;
        break;
    }
    
    if (this.state.isLoading) {
      return (
        <div style={{padding: 10, textAlign: 'center'}}>
          <CircularProgress />
        </div>
      )
    }

    // render return
    return (
      <MuiPickersUtilsProvider
        utils={MomentUtils}
      >
        <Grid container style={{height: 'calc(100% - 50px)'}}>
          <ItemGrid xs={12} sm={12} md={12}>
          {/* the edit/create new event modal */}
          { this.createEventModal() }
          <Button onClick={this._onShowModal.bind(this)}>
            Add New Event
          </Button>
          </ItemGrid>
          {/* render the React Big Calendar */}
          <EventsCard onChangeTab={t => this.onChangeTab(t)}>
            <ItemGrid xs={12} sm={12} md={12}>
              <div style={{height: '50vh', width: '100%', paddingBottom: 50}}>
                <Calendar
                  localizer={momentLocalizer(moment)}
                  // defaultDate={moment().toDate().toISOString()}
                  defaultView="month"
                  events={events}
                  selectable
                  onSelectEvent={(e) => this.initEditEvent(e.id)}
                  onSelectSlot={(e) => this._onShowModal(e.start)}
                  startAccessor={(e) => e.calendarStart? moment(e.calendarStart).toDate() : moment(e.date).toDate()}
                  endAccessor={(e) => e.calendarEnd? moment(e.calendarEnd).toDate() : moment(e.date).toDate()}
                  eventPropGetter={(e) => this.eventStyleGetter(e)}
                />
              </div>
            </ItemGrid>
          </EventsCard>
          {/* Daily Specials header */}
  				<ItemGrid xs={12} sm={12} md={12}>
  				  <h5>
              Daily Special
            </h5>
  				</ItemGrid>
          {/* render the Daily Specials */}
          { this.renderDailySpecials() }
        </Grid>
      </MuiPickersUtilsProvider>
    )
  }
}

const mapDispatchToProps = {
  loadEvents,
  createNewEvent,
  editEvent,
  changeFeature,
  changeStarred,
  deleteEvent,
  deleteAllEventOccurrences,
	saveSpecials,
	loadSpecials,
};

const mapStateToProps = (state) => {
  let events = state.eventReducer.events;
  let allEvents = [];
  let recurringEvents = [];
  let starredEvents = [];
  let featuredEvents = [];
  if (events && !Array.isArray(events)) {
    // event keys
    const keys = Object.keys(events);
    // convert event object to all event array
    for (var k = 0; k < keys.length; ++k) {
      allEvents.push(events[keys[k]]);
    }
    // filter and get repeating events
    var repeating = allEvents.filter((ev) => {
      return ev.repeat !== 'once';
    });
    // console.log('repeating',repeating);
    // cutoff point for recurring events going forward
    const cutoffFuture = moment().add(2, 'months');
    // cutoff point for recurring events going back
    const cutoffPast = moment().subtract(1, 'month');
    // iterate through repeating events
    for (let r = 0; r < repeating.length; ++r) {
      // current event
      let evnt = repeating[r];
      // how often the event is recurring
      let unit = 'day';
      // whether it is every { unit } or every other { unit }
      let frequency = 1;
      // switch values based on value of repeat
      switch(evnt.repeat) {
        case 'week':
        case 'weekly':
          unit = 'week';
          break;
        case '2weeks':
        case 'biweekly':
          frequency = 2;
          unit = 'weeks';
          break;
        case 'month':
        case 'monthly':
          unit = 'month';
          break;
        case 'year':
        case 'yearly':
          unit = 'year';
          break;
        default:
          break;
      }
      // get the original date for event
        let date = evnt.date;
      // if it's before the past cutoff point
      // if (moment(date).isBefore(cutoffPast)) {
      //   // loop until it's not
      //   while (moment(date).isBefore(cutoffPast)) {
      //     date = moment(date).add(frequency, unit);
      //     console.log(unit,date)
      //   }
      // }
      // add regular Event
      recurringEvents.push(evnt);
      // loop until the cutoff point is reached
      // while (moment(date).isBefore(cutoffFuture)) {
      //   // increment date
      //   date = moment.utc(date).add(frequency, unit);
      //   // the object for this recurrence
      //   var recur = {};
      //   // assign event to recur
      //   recur = Object.assign(recur, evnt);
      //   // assign date to recur
      //   recur.date = date;
      //   // assign this event to All Events and Recurring Events
      //   allEvents.push(recur);
      //   recurringEvents.push(recur);
      // }
    }
    // filter and get Featured and Starred Events
    featuredEvents = allEvents.filter((ev) => {
      return ev.isFeatured;
    });
    starredEvents = allEvents.filter((ev) => {
      return ev.isStarred;
    });
  }
  return {
    allEvents: allEvents,
    recurringEvents: recurringEvents,
    starredEvents: starredEvents,
    featuredEvents: featuredEvents,
  	dailySpecials: state.eventReducer.dailySpecials,
  	specialLoading: state.eventReducer.specialLoading,
    user: state.authReducer.user,
    loggedIn: state.authReducer.loggedIn,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(EventView);
